import React, { useState, useEffect } from 'react';
import Sidebar from '../Sidebar';
import Surveys from './Surveys';
import FetchUserDetails from '../../components/UserDetails/FetchUserDetails';


const SurveyHome = () => {
  // Initialize sidebar state from sessionStorage, default to false (expanded)
  const [isGetUserDetailsFunctionExecuted, setIsGetUserDetailsFunctionExecuted] = useState(false);
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
      const savedState = sessionStorage.getItem('isSidebarCollapsed');
      return savedState ? JSON.parse(savedState) : false;
  });

  // Update sessionStorage whenever isSidebarCollapsed changes
  useEffect(() => {
    sessionStorage.setItem('isSidebarCollapsed', JSON.stringify(isSidebarCollapsed));
  }, [isSidebarCollapsed]);

  // Toggle sidebar state
  const handleToggleSidebar = () => {
    setIsSidebarCollapsed((prev) => !prev);
  };
  // Update sessionStorage whenever isSidebarCollapsed changes
  useEffect(() => {
    sessionStorage.setItem('isSidebarCollapsed', JSON.stringify(isSidebarCollapsed));
  }, [isSidebarCollapsed]);

  useEffect(() => {
    const getUserDetails = async () => {
      try {
        if (
          sessionStorage.getItem('user_name') &&
          sessionStorage.getItem('user_emailId') &&
          sessionStorage.getItem('user_id')
        ) {
          console.log('User details already exist in sessionStorage.');
          setIsGetUserDetailsFunctionExecuted(true);
          return;
        }

        const userFetched = await FetchUserDetails();
        if (userFetched) {
          console.log('User details fetched successfully.');
        } else {
          console.error('Failed to fetch user details.');
        }
      } catch (error) {
        console.error('Error fetching user details:', error);
      } finally {
        setIsGetUserDetailsFunctionExecuted(true);
      }
    };

    getUserDetails();
  }, []);

  if (!isGetUserDetailsFunctionExecuted) {
    return null; // Optionally show a loading spinner here
  }
  return (
    <div id="home1">
      <Sidebar onToggleSidebar={handleToggleSidebar} isCollapsed={isSidebarCollapsed} />
      <div id="home2" className={`survey-home-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <Surveys />
      </div>
    </div>
  );
};

export default SurveyHome;